export enum NotificationEnum {
  PromoPopup = 1,
  NotificationPanel = 2,
}

export type NotificationType = {
  id: ID;
  title: string;
  description: string;
  imageUrl: string;
  submitUrl: string;
  type: NotificationEnum;
  createdAt: string;
  updatedAt: string;
};

export type NotificationResponseType = {
  totalCount: number;
  query: Notification[];
  perPage: number;
  page: number | null;
};

export type VideoType = {
  thumbnail: string;
  youtubeVideoId: string;
};
